// extracted by mini-css-extract-plugin
export default {"list":"list--Y-ss-","bullet":"bullet--35dPn","step":"step--yy8bz"};